import React, {
	useEffect,
	useState
} from 'react'

import {
	useDispatch,
	useSelector
} from 'react-redux'

import {
	closeProgramAssignments,
	selectProgramById
} from '../programsSlice'

import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import Table from 'react-bootstrap/Table'
import Spinner from 'react-bootstrap/Spinner'
import Modal from 'react-bootstrap/Modal'
import DatePicker from "react-datepicker"
import Form from "react-bootstrap/Form"
import { envAwarePost } from '../../../util/util'
import { dateToAPIStandard } from '../../../util/datetime'
import useApiStatusEnvAwarePost from '../../../hooks/useApiStatusEnvAwarePost'

const AssignmentRow = ({assignment, setMode, assignmentsIds, setAssignmentsIds,setDeleteType,})=>{
	const statusPost = useApiStatusEnvAwarePost()
	const [status,setStatus] = useState('idle')
	const [date,setDate] = useState(new Date(assignment.start_date.replace(/-/g, '\/')))
	const handleDateChange = (newDate)=>{
		setStatus('pending')
		setDate(newDate)
		const postData = {
			action:'updateProgramAssignmentDate',
			assignment_id:assignment.id,
			date:dateToAPIStandard(newDate)
		}
		statusPost('api/programs/api/',postData,'assignment','edit').then(res=>{
			setStatus('idle')
		})
	}
	return (
		<tr>
			<td>
				{assignment.assigned_user_name} <br />
				<div>
					<small>Update date</small>
					<DatePicker
						disabled={status==='pending'}
						selected={date}
						onChange={handleDateChange}
						className="ml-1" />
					{status==='pending'&&<Spinner animation="border" size="sm"/>}
				</div>
			</td>
			<td className="text-right">
			<Form.Check
				className="mr-2"
				type={"checkbox"}
				value={assignmentsIds.includes(assignment.id)}
				onChange={()=>{
					if (assignmentsIds.includes(assignment.id)){
						let newAssignments = assignmentsIds.filter(item=>item !== assignment.id)
						setAssignmentsIds(newAssignments);
					} else {
						setAssignmentsIds(prev=>[...prev, assignment.id])
					}
				}}
				id={`program-checkbox-${assignment.id}`}
      		/>
			</td>
		</tr>
	)
}

const AssignmentsEditor = () => {
	const dispatch = useDispatch()
	const show = useSelector(state => state.programs.assignmentsEditor.show)
	const program_id = useSelector(state => state.programs.assignmentsEditor.program_id)
	const program = useSelector(state=>selectProgramById(state,program_id))

	const [assignments, setAssignments] = useState([])
	const [status, setStatus] = useState('loading')
	//mode one of ['init','confirm']
	const [mode, setMode] = useState('init')
	const [deleteType, setDeleteType] = useState(null)
	const [assignmentIds, setAssignmentIds] = useState([]);

	useEffect(() => {
		if (!program_id) return
		setStatus('loading')
		envAwarePost('api/programs/api/', {
			action: 'getProgramAssignments',
			program_id
		}).then(res => {
			console.log(res.data)
			setStatus('idle')
			if (res.success === '1') {
				setAssignments(res.data)
			} else {
				alert(res.message)
			}
		})
	}, [program_id, show])

	const deleteAssignments = (assignment_ids, future_only) => {
		//console.log(assignment_id)
		const update = assignments.filter(assignment => !assignment_ids.includes(assignment.id))
		setAssignments(update)
		envAwarePost('api/programs/api/', {
			action: 'deleteMultipleProgramAssignments',
			assignment_ids,
			future_only
		}).then(res => {
			if (res.success === '1') {
				setAssignmentIds([]);
				//setAssignments(res.data)
			} else {
				alert(res.message)
			}
		})
	}

	const deleteAllAssignments = (future_only) => {
		setAssignments([])
		envAwarePost('api/programs/api/', {
			action: 'deleteAllProgramAssignments',
			program_id,
			future_only
		}).then(res => {
			if (res.success === '1') {
			} else {
				alert(res.message)
			}
		})
	}

	const modeComponentMap = {
		init: (
			assignments.length === 0 ?
				<div>No assignments</div> :
				<div>
					<Button
						onClick={() => {
							setMode('confirm')
							setDeleteType('all')
						}}
						variant="outline-danger"
						className="mb-2">
						Delete All Assignments
					</Button>
					
					
					<Table striped>
						<thead>
							<tr>
								<th>Details</th>
								<th>		
								<Button 
									className=" float-right"
									size="sm"
									variant="outline-danger"
									style={{cursor: "pointer"}}
									onClick={() => {
										setMode('confirm')
										setDeleteType('one')}}
									 >
										 <i className="fas fa-trash"></i>
								</Button>			

								</th>
							</tr>
						</thead>
						<tbody>
							{assignments.map(assignment => (
								<AssignmentRow
									assignmentsIds={assignmentIds}
									setAssignmentsIds = {setAssignmentIds}
									setDeleteType={setDeleteType}
									assignment={assignment}
									setMode={setMode}
								/>
							))}
						</tbody>
					</Table>
				</div>
		),
		confirm: (
			<div>
				{deleteType==='all'&&
					<Alert variant="danger" className="text-dark mb-4">
						<strong className="mr-2">WARNING:</strong>
						YOU ARE DELETING ALL ASSIGNMENTS
					</Alert>
				}
				<Button
					onClick={() => {
						if (!window.confirm('Delete all future events?')) return
						setMode('init')
						const futureOnly = 1
						if (deleteType === 'all') {
							deleteAllAssignments(futureOnly)
						} else {
							deleteAssignments(assignmentIds, futureOnly)
						}
					}}
					block
					variant="outline-danger"
					size="sm"
					className="mb-4 text-left text-wrap">
					Remove all <strong>FUTURE</strong> workout, task & nutrition data related to this program
					from <strong>{deleteType === 'all' ? 'ALL CLIENTS' : 'THIS CLIENT'}</strong>. <em>You will <strong>NOT</strong> lose data for completed events</em>.
				</Button>
				<Button
					onClick={() => {
						if (!window.confirm('Wipe the entire program?')) return
						setMode('init')
						//dispatch(closeProgramAssignments())
						const futureOnly = 0
						if (deleteType === 'all') {
							deleteAllAssignments(futureOnly)
						} else {
							deleteAssignments(assignmentIds, futureOnly)
						}
					}}
					block
					variant="outline-danger"
					size="sm"
					className="text-left text-wrap">
					Wipe program from <strong>{deleteType === 'all' ? 'ALL CLIENTS' : 'THIS CLIENT'}</strong>. This will delete <strong>ALL</strong> workout, task & nutrition data related to this program
					from <strong>{deleteType === 'all' ? 'ALL CLIENTS' : 'THIS CLIENT'}</strong>. <em>You <strong>WILL LOSE</strong> data for completed events.</em>
				</Button>
			</div>
		),
	}
	return (
		<Modal centered show={show} onHide={() => {
			setMode('init')
			dispatch(closeProgramAssignments())
		}}>
			<Modal.Header closeButton>
				<div className="d-flex align-items-center">
					{mode === 'confirm' &&
						<Button className="mr-2" size="sm" onClick={() => setMode('init')} variant="outline-dark">
							Back
						</Button>
					}
					{program?.programName} - {mode === 'init' ? 'Assignments' : 'Delete Options'}
				</div>
			</Modal.Header>
			<Modal.Body>
				{
					status === 'loading' ?
						<Spinner animation="border" role="status">
							<span className="sr-only">Loading...</span>
						</Spinner> : 
					modeComponentMap[mode]
				}
			</Modal.Body>
		</Modal>
	)
}

export default AssignmentsEditor